<template>
  <div class="m-content">
    <AbilityCategory v-for="(item,index) in categoryArray" :content="item" v-on:listenToChildEvent="getAnswer"></AbilityCategory>
    <SelectAbility v-for="(item,index) in categoryArray" :content="item" v-on:listenToChildEvent="getAnswer"></SelectAbility>
    <div class="btn-group">
      <button class="default-btn large-btn" :class="show?'half-opacity':''" v-if="showButton" @click="showNext" v-preventReClick>下一步</button>
      <button class="default-btn large-btn submit-btn" v-if="submit" @click="submitData" v-preventReClick>提交</button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import AbilityCategory from '../components/AbilityCategory.vue'
  import SelectAbility from '../components/SelectAbility'
  import axios from 'axios'
  import qs from 'qs'
  import setWechatTitle from '@/utils/setWechatTitle.js'
  export default {
    props: {
      id: Number
    },
    name: 'Ability',
    components: {
      'AbilityCategory':AbilityCategory,
      'SelectAbility':SelectAbility
    },
    data() {
      return {
        categoryArray:[
          {'num':1,'title':'1、请填写你的目标职业或职位','type':6,'show':true,'errorMessage':'',},
          {'num':2,'title':'2、在职业世界中有几大不同类型的职业，上面的这个目标职业属于哪个职业领域呢？请选择。','options':['技术/专业人员（软件开发人员、工程师、应用研究科学家、经济、金融领域的专业职务等）','业务人员（销售、市场人员等）','人类服务工作者（医务工作者、教师、顾问、辅导人员等）','管理人员（在企业、组织担任管理者）'],'type':7,'show':true},
          {'num':3,'title':'','type':8,'show':false,'errorMessage':'','option1':[{'name':'成就导向','definition':'不满足于现状，对成功具有强烈的渴求，努力克服障碍，力图达到较高目标，其标准可以是某个人自己过去的业绩(力求改进之)；或一种客观衡量标准(只论结果)；或比其他人做得更好(即竞争性)；或某人自己设定的挑战性目标；或任何人从未做过的事(改革性)。'},{'name':'主动性','definition':'在完成某项活动的过程中，自在驱动去行动的动力的强度。在没有人要求的情况下，超乎工作预期和原有需要层级的努力，这些付出可以改善及增加工作效益，以及避免问题的发生，或创造一新的机会。'},{'name':'问题解决','definition':'对于工作中出现的问题，能够抓住其本质，提出创造性的解决方案，并付诸实施。'},{'name':'坚韧性','definition':'克服一切去执行决定，在任务困难面前或威胁利诱面前都毫不动摇，坚持不懈地去实现既定目标。'},{'name':'重视次序、品质与精确','definition':'重视次序，反映出降低环境不确定性的潜在动机。'},{'name':'组织承诺','definition':'与上级组织目标、需要保持一致，能够把组织的使命放在个人的喜好之上。其行为不是个人兴趣而是与组织目标更相关。也指个体认同并参与一个组织的强度，一种“心理合同”，或“心理契约”。'}],
          'option2':[{'name':'人际理解','definition':'理解他人的思想、感情与行为的能力。有理解他人的愿望，能够帮助一个人体会他人的感受，通过他人的语言、语态、动作等理解并分享他人的观点，抓住他人未表达的疑惑与情感，把握他人的需求，并采取恰如其分的语言帮助自己与他人表达情感。'},{'name':'服务精神','definition':'为某种事业、集体、他人工作的思想意识和心理状态。具有服务精神的人有帮助或服务客户的愿望以满足他们的要求，即专注于如何发现并满足客户的需求。'}],
          'option3':[{'name':'影响力','definition':'为了使他人赞成或支持自己，用一种为别人所乐于接受的方式，改变他人所乐于接受的方式，改变他人的思想和行动的能力，希望他人采用的一系列行动。'},{'name':'组织意识','definition':'对组织的组织结构、决策链、权力关系以及组织政治的敏感性。'},{'name':'关系建立','definition':'指与有助于或可能有助于完成工作相关目标的人，建立或维持友善、温暖的关系或联系网络的能力。这种能力还被理解为建立网络、资源利用、开发人脉、对顾客的关切、建立融洽的关系的能力。'},{'name':'沟通协调','definition':'在日常工作中妥善处理好上级、同级、下级等各种关系，使其减少摩擦，能够调动各方面的工作积极性的能力。'},{'name':'语言表达','definition':'通过语言、肢体动作等方式通俗流畅的表达自己的意见、看法或见解的能力。'}],
          'option4':[{'name':'培养他人','definition':'指自发的、真诚的去帮助他人提高工作上的知识技能、工作方法和能力素质等。有培养他人的意愿与倾向，关注他们的潜能与可塑性，并在实际工作中帮助其成长。'},{'name':'命令与果断','definition':'命令表达出个人促使他人依照其希望行事的企图，命令的行为带有“告诉人们去做什么”的主题或语调。命令需要以组织的长期利益来考量，适当且有效运用个人权力或个人职位上的权力。'},{'name':'团队合作','definition':'与他人通力合作、成为团队一部分一起工作而非分开工作或互相竞争。'},{'name':'领导能力','definition':'有意做一群人的领导，能够领导人们有效地在一起工作，激励他人跟随要去的地方。'}],
          'option5':[{'name':'分析式思考','definition':'将情况细分成较小的部分，或一步步探究来进行分析。有系统的把一个问题的各个部分组织起来，有系统的比较问题的不同构面，依靠理性找到先后次序或因果关系。'},{'name':'概念（归纳）式思考','definition':'有能力确认那些不明显相关事物的规律或关联，在极为复杂的情况下，确定出关键或潜在的问题。包括运用创造性的、概念化的或归纳性的推理方法。'},{'name':'信息收集与分析','definition':'能够把那些原始的、零散的材料经过归纳整理，综合分析，去粗取精，去伪存真，变成系统的、具有较强操作性和指导性的意见、建议。由于潜在的好奇和愿望趋，采用不一般的方式去收集信息。并能够把那些原始的、零散的材料经过归纳整理，综合分析，去粗取精，去伪存真，变成系统的、具有较强操作性和指导性的意见、建议。'},{'name':'学习发展','definition':'通过吸取自己或他人经验教训、科研成果等方式，增加学识、提高技能，从而获得有利于未来发展的能力。'},{'name':'创新','definition':'不受陈规和以往经验的束缚，不断改进工作学习方法，以适应新观念、新形势发展的要求。为了满足自身需要，不断拓展对客观世界及其自身的认知与行为的过程和结果的活动。是为了一定的目的，遵循事物发展的规律，对事物的整体或其中的某些部分进行变革，从而使其得以更新与发展的活动。'},{'name':'分析判断','definition':'对已知的事实进行分析推理，把握事情的本质。'},{'name':'专业知识','definition':'专业知识包括对工作相关知识的精通了解（可能是技术、职业或管理方面），以及延伸、利用和传播工作相关知识给他人的动机。'}],
          'option6':[{'name':'自我控制','definition':'又称自我管理、自我控制、自我调整、自律性管理，指个体对自身的心理与行为的主动掌握，调整自己的动机与行动，以达到所预定的模式或目标的自我实现过程。它是一种人格特质。有较强的自我认知能力，能够按计划去完成自己该完成的工作。'},{'name':'自信心','definition':'自信心是指一个人相信自己具备完成某项任务的能力，包括TA在处理困难的环境、下决定或产生想法、积极处理挫败时所表达的信心。'},{'name':'弹性','definition':'弹性是指一个人在不同环境下，与不同个人或团体工作时表现出的适应与有效工作能力，弹性可以让人在情况有所变动时，可以依照情况需求来应变做事的方式。'},{'name':'其他','definition':'正确的自我评估、从错误中学习的能力</br>职业偏好，非常喜爱自己的工作，从工作中得到乐趣</br>对工作保持忠诚度：全力达成任务</br>喜欢与人接触，真的对他人有兴趣</br>对他人有正面的期待'}]
          }
        ],
        show:true,
        showButton:true,
        submit:false,
        allowSubmit:false,
        answers:[{'num':1,'answer':''},{'num':2,'answer':''},{'num':3,'answer':''},{'num':4,'answer':''},{'num':5,'answer':''},{'num':6,'answer':''},{'num':7,'answer':''},{'num':8,'answer':''}],
        submitNum:0
      }
    },
    computed: {
      ...mapState({
        shengyaUser: state => state.shengyaUser.userInfo,
      }),
    },
    created(){
      setWechatTitle('生涯驿站-目标职位能力大赏');
    },
    methods:{
      // 从子组件获取答案
      getAnswer(text,num){
        if(num==3&&text.length>0){
          text.map((item,zindex)=>{
            let answer=''
            item.list.map((pep,index)=>{
              answer+=(index+1)+"<"+pep.name
              if(index<item.list.length){
                answer+=','
              }
            })
            this.$set(this.answers,item.sub-1,{'num':item.sub,'answer':answer})
            this.allowSubmit = true
          })
        }else{
          if(num==1){
            this.categoryArray[2].title=text
          }
          this.$set(this.answers,num-1,{'num':num,'answer':text})
          if(this.answers[0].answer&&typeof(this.answers[1].answer)=="number"){
            this.show=false
          }
        }
      },
      // 显示下一步
      showNext(){
        if(this.answers[0].answer&&typeof(this.answers[1].answer)=="number"){
          this.submit = true
          this.showButton = false
          this.categoryArray[2].show=true
          this.categoryArray[0].show=false
          this.categoryArray[1].show=false
        }
      },
      // 提交数据
      submitData(){
        if(this.allowSubmit&&this.submitNum==0){
          this.submitNum =1
          let result = ''
          this.answers.map((item,index)=>{
            if(item.answer||typeof(item.answer)=="number"){
              result+=item.num+"$"+item.answer
            }else{
              result+=item.num+"$"+"空"
            }
            if(item.num<8){
              result+='}'
            }
          })
          const options = {
            method: 'POST',
            headers: {
              'content-type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify({
              submitdata:result,
              openId: this.shengyaUser.openid
            }),
            url: '/cob/saveCosAbilityAnswer.do'
          };
          axios(options)
            .then((response)=>{
              if(response.data.result.success){
                let cddqAnswer = response.data
                let shengyaUser = cddqAnswer.data.user
                this.$bus.$emit('play-finish', shengyaUser)
              }else{
                this.$store.commit('showMessage', {
                  message: response.data.result.message,
                  type: 'error'
                })
              }
            })
            .catch((error)=>{
              console.log(error);
            });
        }else{
          this.categoryArray[2].errorMessage="至少选择10项"
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>

</style>
